export const toMoisAnnee = d =>
  d.toLocaleString("default", { month: "long", year: "numeric" });

export const toSimple = d => {
  var options = {
    weekday: "short",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  };
  var locale = "default";
  return d.toLocaleString(locale, options);
};
